<template>
  <div
    class="alert d-flex align-items-center"
    :class="[
      `alert-${type}`,
      { 'is-closable': closable }
    ]"
    v-show="visible"
  >
    <div class="d-flex align-items-center justify-content-center flex-grow-1">
      <img 
        v-if="type"
        class="me-2" 
        :src="getIconPath(type)" 
        alt="warning" 
        style="width: 16px; height: 16px;"
      />
      <div>
        <div v-if="title">
            {{ title }}
            <span 
            v-if="clickableText" 
            class="cursor-pointer text-decoration-underline"
            @click="handleClick"
          >
            {{ clickableText }}
          </span>
        </div>
      </div>
    </div>
    <div 
      v-if="closable" 
      class="position-absolute top-0 end-0 p-2"
      @click="close"
    >
      <span class="text-secondary">×</span>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import warningIcon from '../../../assets/icons/warning.svg'
// import successIcon from '../../assets/icons/success.svg'
// import infoIcon from '../../assets/icons/info.svg'
// import errorIcon from '../../assets/icons/error.svg'

defineOptions({
  name: 'ScanatAlert'
})

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'warning',
    validator: (value) => ['success', 'warning', 'info', 'error'].includes(value)
  },
  closable: {
    type: Boolean,
    default: false
  },
  clickableText: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['close', 'click'])
const visible = ref(true)

const close = () => {
  visible.value = false
  emit('close')
}

const handleClick = () => {
  emit('click')
}

const getIconPath = (type) => {
  const icons = {
    warning: warningIcon,
    // success: successIcon,
    // info: infoIcon,
    // error: errorIcon
  }
  return icons[type] || warningIcon
}
</script>

<style scoped>
.alert {
  height: 2.375rem;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: .875rem;
}

.alert-warning {
  background-color: #FFF1E4 !important;
  color: #B96515 !important;
}

.alert-success {
  background-color: #F6FFED;
  border: 1px solid #B7EB8F;
  color: #52c41a;
}

.alert-info {
  background-color: #E6F4FF;
  border: 1px solid #91D5FF;
  color: #1890ff;
}

.alert-error {
  background-color: #FFF1F0;
  border: 1px solid #FFA39E;
  color: #ff4d4f;
}

.cursor-pointer {
  cursor: pointer;
}
</style> 